import { render, staticRenderFns } from "./JdSkuInfoCard_No_Pid.vue?vue&type=template&id=66ecf53a&scoped=true&"
import script from "./JdSkuInfoCard_No_Pid.vue?vue&type=script&lang=js&"
export * from "./JdSkuInfoCard_No_Pid.vue?vue&type=script&lang=js&"
import style0 from "./JdSkuInfoCard_No_Pid.vue?vue&type=style&index=0&id=66ecf53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ecf53a",
  null
  
)

export default component.exports